import React, { useState } from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import styles from './CaseTypeWizardShiftsCheck.module.scss';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
import ManagerWorkplaceOnlineOrderTargetSetupModal from '../../Workplace/ManagerWorkplaceOnlineOrderTargetSetup/ManagerWorkplaceOnlineOrderTargetSetupModal';
import { CreateCaseTarget } from '../../../../Base/Enums/CreateCaseTarget.enum';
import useOnlineOrderTarget from '../../../Hooks/useOnlineOrderTarget';
import Loading from '../../../../../Components/Loading';

interface Props {
	onClose: () => void;
	onRedirectToShifts: () => void;
	workplaceId: string;
}

const CaseTypeWizardShiftsCheck: React.FC<Props> = ({
	onClose,
	onRedirectToShifts,
	workplaceId,
}) => {
	const [isChangeWorkplaceSettingsOpen, setIsChangeWorkplaceSettingsOpen] =
		useState(false);
	const { isLoading, onlineOrderTarget, refetchOnlineOrderTarget } =
		useOnlineOrderTarget(workplaceId);

	const handleOnWorkplaceSettingsChange = async () => {
		setIsChangeWorkplaceSettingsOpen(false);
		await refetchOnlineOrderTarget();
	};

	const handleSetupServiceScheduleNow = () => {
		onClose();
		onRedirectToShifts();
	};

	let component: React.ReactNode = (
		<div className={styles.wrapper}>
			<div className={styles.iconWrapper}>
				<img src='/dist/icons/green-check.svg' alt='Check' height='30px' />
				<Text
					className={styles.bold}
					tx='component.caseTypeWizardShiftsCheck.allGood'
				/>
			</div>
			<Text
				className='mt-3'
				tx='component.caseTypeWizardShiftsCheck.noNeedToSetupShifts'
			/>
			<div className={styles.controls}>
				<Button
					theme={Theme.GREEN}
					title='base.shared.save'
					onClick={onClose}
					fitContent
				/>
				<LinkButton
					title='component.caseTypeWizardShiftsCheck.changeSettings'
					theme={Theme.BLUE}
					onClick={() => setIsChangeWorkplaceSettingsOpen(true)}
				/>
			</div>
		</div>
	);

	if (onlineOrderTarget === CreateCaseTarget.WORKPLACE_MEMBER) {
		component = (
			<div className={styles.wrapper}>
				<div className={styles.iconWrapper}>
					<img
						src='/dist/icons/triangle-exclamation-solid-full.svg'
						alt='warning'
						height='30px'
					/>
					<Text
						tx='component.caseTypeWizardShiftsCheck.checkShitsSetup'
						className={styles.bold}
					/>
				</div>
				<Text tx='component.caseTypeWizardShiftsCheck.text1' />
				<Text tx='component.caseTypeWizardShiftsCheck.text2' />
				<Text tx='component.caseTypeWizardShiftsCheck.text3' />
				<div className={styles.controls}>
					<Button
						theme={Theme.GREEN}
						title='component.caseTypeWizardShiftsCheck.goToShifts'
						onClick={handleSetupServiceScheduleNow}
					/>
					<LinkButton
						title='component.caseTypeWizardShiftsCheck.changeSettings'
						theme={Theme.BLUE}
						onClick={() => setIsChangeWorkplaceSettingsOpen(true)}
					/>
				</div>
			</div>
		);
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<>
			{component}
			{isChangeWorkplaceSettingsOpen && onlineOrderTarget && (
				<ManagerWorkplaceOnlineOrderTargetSetupModal
					isOpen
					workplaceId={workplaceId}
					onClose={() => setIsChangeWorkplaceSettingsOpen(false)}
					defaultData={{ onlineOrderTarget }}
					onUpdate={handleOnWorkplaceSettingsChange}
				/>
			)}
		</>
	);
};

export default CaseTypeWizardShiftsCheck;
